import * as React from "react";
const Component = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 1000 1000" {...props}><rect width="100%" height="100%" fill="transparent" /><path d="m2995 9310-280-280 283-283 282-282 282 282 283 283-280 280c-154 154-282 280-285 280s-131-126-285-280" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.54 1658.582)" /><path d="M2975 8144c-165-156-301-288-302-292-2-4 41-29 94-57 117-60 326-198 443-291 112-90 299-277 383-384 193-243 333-516 406-791 35-131 71-331 71-394 0-82-41-75 461-75h449v36c0 50-27 230-51 339-87 394-276 817-519 1160-203 286-485 578-767 793-112 85-344 242-357 242-6 0-146-129-311-286" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.542 1658.619)" /><path d="M2484 7143c-262-224-437-470-500-706-23-84-23-252-1-336 10-35 30-89 46-120l28-56 393-3c371-2 392-1 387 15-4 10-18 52-33 93-23 64-27 91-26 185 1 281 152 577 454 891l101 104h-770z" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.564 1658.657)" /><path d="M3585 6743c-64-168-202-418-316-573-94-128-286-314-405-393-157-104-336-177-477-195l-59-7 249-288 248-289 46 6c240 32 491 166 694 370 122 124 194 220 281 376 58 102 59 106 57 175-5 177-68 422-162 631-37 81-123 234-132 234-4 0-14-21-24-47" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.553 1658.67)" /><path d="M6681 5950c-18-33-30-64-27-68 3-5 23-21 46-37 38-27 41-27 59-11 30 28 52 82 45 111s-48 65-74 65c-11 0-29-22-49-60" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.417 1658.694)" /><path d="M7288 5911c-39-69-37-92 14-126 47-31 59-28 96 25 31 46 29 85-7 121-44 44-71 39-103-20" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.398 1658.696)" /><path d="M6774 5830c-15-22-29-40-31-40-3 0-19 11-35 25-17 14-38 25-46 23-18-3-82-105-82-129 0-16 69-69 89-69 10 0 57 52 64 72 3 9 13 5 34-14 35-34 53-35 80-5 60 65 55 131-14 166-30 15-30 16-59-29" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.42 1658.7)" /><path d="M6244 5603c-64-85-566-655-571-649-2 2 8 84 22 182 28 200 28 204 17 204-5 0-25-44-45-97-40-112-75-320-84-504-6-130 3-177 44-209 78-61 194 25 243 181 13 41 24 75 25 76 0 1 35-9 76-24 144-50 379-44 629 17 468 115 812 364 940 682 34 87 47 138 34 138-14 0-74-95-99-158-103-254-619-500-1110-530-150-9-250-2-400 26-60 12-125 23-142 24l-33 3 221 260c215 253 259 316 274 383 9 43-6 41-41-5m-431-779c37-20 33-51-12-81-66-44-141-16-141 53 0 26 5 34 28 43 32 12 84 5 125-15" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.45 1658.706)" /><path d="M4586 5545c-15-24-29-57-32-73-5-25-1-32 35-55 22-15 47-27 54-27 32 0 77 83 69 126-5 29-56 74-82 74-11 0-28-18-44-45" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.483 1658.708)" /><path d="M5157 5483c-45-102-48-115-68-319-10-111-23-223-28-248s-5-46 0-46c14 0 56 82 73 140 9 30 25 141 36 245 11 105 22 211 26 238 9 65-7 60-39-10" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.467 1658.71)" /><path d="M4930 5448c-37-94-46-144-59-321-5-78-14-133-22-143-7-9-38-28-68-44-72-36-123-90-160-167-36-73-47-84-173-175-111-79-125-104-51-93 121 18 193 67 234 160 34 78 55 102 120 136 122 66 177 200 209 513 6 60 15 130 20 155 8 46 6 61-9 61-5 0-23-37-41-82" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.49 1658.71)" /><path d="M5902 5422c-56-55-102-102-102-105 0-17 32-4 77 31 87 65 170 172 135 172-5 0-54-44-110-98" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.444 1658.71)" /><path d="M3800 5288c-41-91-47-124-65-323-9-99-21-202-26-229-11-59-11-56-1-56 15 0 60 92 76 155 8 33 24 149 36 257 11 108 23 210 26 227 11 54-15 35-46-31" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.51 1658.715)" /><path d="M7525 5213c-40-89-53-148-65-288-13-149-29-280-37-301-10-27 17-14 37 19 37 59 59 160 80 356 11 106 23 211 26 232 10 58-12 49-41-18" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.393 1658.717)" /><path d="M4430 5150c-11-26-18-30-49-30-107 0-187-66-317-263-93-141-219-278-306-332-46-29-68-65-30-50 112 42 241 154 358 310 130 174 167 200 271 189 54-6 60-4 87 22 53 53 73 136 40 168-23 24-40 19-54-14" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.51 1658.72)" /><path d="M7856 4893c-51-105-51-97-1-153 25-28 45-58 45-67 0-17-71-91-130-135-44-33-33-46 25-30 89 24 138 72 176 171 36 95 22 172-41 225-42 35-53 33-74-11" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.383 1658.728)" /><path d="M5324 4888c-30-32-53-80-63-131-5-23-17-72-26-109-17-64-17-68 1-105 21-43 55-53 104-33 57 24 129 167 130 257 0 87-26 125-96 139-22 4-34 0-50-18m25-173c42-21 47-46 16-72-14-13-33-23-42-23-21 0-53 29-48 43 2 7 6 24 9 40 7 31 24 34 65 12" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.462 1658.73)" /><path d="M3569 4888c-39-32-73-105-62-134 7-19 59-18 67 2 12 31 6 53-16 56-21 3-21 4 6 35 29 35 33 63 5 41" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.516 1658.73)" /><path d="M4216 4798c-88-102-101-208-26-208 33 0 70 40 70 76 0 25-33 49-56 40-12-5-12-1 1 23 8 16 26 42 40 59 26 31 32 52 16 52-5 0-26-19-45-42" style={{
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeDashoffset: 0,
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    isCustomFont: "none",
    fontFileUrl: "none",
    fill: "4C8251",
    fillRule: "nonzero",
    opacity: 1
  }} transform="matrix(.1648 0 0 -.1648 -320.496 1658.73)" /></svg>;
export default Component;
export { Component as ReactComponent };